import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable";
import { getAllMasterStays } from "../../../../core/data/redux/masterStaySlice";
import { AppDispatch, RootState } from "../../../../core/data/redux/store";
import { all_routes } from "../../../router/all_routes";
type StayType = {
    id: number;
    stay_id: string;
    stay_title: string;
    created_at: string;
    modified_at: string;
};

type PaginationType = {
    current: number;
    pageSize: number;
    total: number;
    query: string;
};

const StayMaster = () => {
    const dispatch = useDispatch<AppDispatch>();
    const routes = all_routes;

    const { loading, masterStays } = useSelector((state: RootState) => state.masterStaysState);

    const [searchParams, setSearchParams] = useState({
        stayId: "",
        stayTitle: "",
    });

    const [debouncedQuery, setDebouncedQuery] = useState("");

    const [pagination, setPagination] = useState<PaginationType>({
        current: 1,
        pageSize: 10,
        total: 0,
        query: "",
    });

    const [dataList, setDataList] = useState<StayType[]>([]);

    useEffect(() => {
        const combinedQuery = [searchParams.stayId, searchParams.stayTitle]
            .filter(Boolean)
            .join(" ")
            .trim();

        const delay = setTimeout(() => {
            setPagination((prev) => ({ ...prev, current: 1, query: combinedQuery }));
            setDebouncedQuery(combinedQuery);
        }, 400);

        return () => clearTimeout(delay);
    }, [searchParams]);

    useEffect(() => {
        dispatch(
            getAllMasterStays({
                page: pagination.current,
                limit: pagination.pageSize,
                query: pagination.query,
            })
        );
    }, [dispatch, pagination.current, pagination.pageSize, pagination.query]);

    useEffect(() => {
        console.log(masterStays?.data.data, 'jsvdnvksdjn')
        if (loading === "fulfilled" && Array.isArray(masterStays?.data?.data)) {
            const allData: StayType[] = masterStays.data.data;

            const filteredData = allData.filter((item) => {
                const searchableString = (item.stay_id + " " + item.stay_title).toLowerCase();
                return searchableString.includes(debouncedQuery.toLowerCase());
            });
            console.log(filteredData, 'ksvdksvldnlkvsd')
            const total = masterStays.data.total;
            const startIndex = (pagination.current - 1) * pagination.pageSize;
            const paginated = filteredData.slice(startIndex, startIndex + pagination.pageSize);

            setDataList(paginated);
            setPagination((prev) => ({
                ...prev,
                total,
            }));
        } else {
            setDataList([]);
        }
    }, [masterStays?.data, loading, debouncedQuery, pagination.current, pagination.pageSize]);

    // Handle pagination changes
    const handlePagination = (newPagination: PaginationType) => {
        setPagination((prev) => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        }));
    };

    const handleSearch = (field: keyof typeof searchParams, value: string) => {
        setSearchParams((prev) => ({
            ...prev,
            [field]: value,
        }));
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const getSerialNumber = (index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1;

    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            width: 90,
            render: (_: any, __: StayType, index: number) => <div>{getSerialNumber(index)}</div>,
        },
        {
            title: "Stay ID",
            dataIndex: "stay_id",
            width: 150,
        },
        {
            title: "Stay Title",
            dataIndex: "stay_title",
            width: 200,
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            width: 180,
            render: (created_at: string) => (
                <div>{formatDate(created_at)}</div>
            ),
        },
        {
            title: "Modified At",
            dataIndex: "modified_at",
            width: 180,
            render: (modified_at: string) => (
                <div>{formatDate(modified_at)}</div>
            ),
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="my-auto mb-2">
                        <h3 className="page-title mb-1">Master Stay</h3>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={routes.adminDashboard}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="#">Settings</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Master Stay
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div className="card">

                    <div className="card-body p-0 py-3">
                        <Table
                            columns={columns}
                            dataSource={dataList}
                            Selection={false}
                            paginationConfig={pagination}
                            handlePagination={handlePagination}
                            loading={loading === "pending"}
                        >

                            <div className="col-sm-12 col-md-6 d-flex justify-content-end">
                                <input
                                    type="text"
                                    placeholder="Search Stay Title"
                                    className="form-control form-control-sm"
                                    value={searchParams.stayTitle}
                                    onChange={(e) => handleSearch("stayTitle", e.target.value)}
                                    style={{ maxWidth: "250px" }}
                                />
                            </div>

                        </Table>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default StayMaster;
